const messages = {
  INVALID_CREDENTIALS: '현재 비밀번호가 올바르지 않습니다.',
  ACCOUNT_EMAIL_REQUIRED: '회원 정보에 이메일을 먼저 등록해 주세요.',
  ACCOUNT_EMAIL_PASSWORD_LOCKED: '현재 비밀번호 확인이 여러 번 실패했습니다. 15분 후 다시 시도해 주세요.',
  ACCOUNT_MAIL_UNAVAILABLE: '현재 확인 메일을 사용할 수 없습니다. 운영 담당자에게 문의해 주세요.',
  ACCOUNT_MAIL_RATE_LIMITED: '요청이 많습니다. 1분 뒤 다시 시도해 주세요. 계정당 한 시간에 3회까지 요청할 수 있습니다.',
  INVALID_RECOVERY_TOKEN: '토큰이 올바르지 않거나 만료·사용되었습니다. 최근 메일을 확인하거나 다시 요청해 주세요.',
  INVALID_PASSWORD: '새 비밀번호는 8자 이상이며 영문을 포함해야 합니다.',
  ACCOUNT_SMS_UNAVAILABLE: '현재 휴대폰 문자 인증을 사용할 수 없습니다. 이메일로 찾거나 운영 담당자에게 문의해 주세요.',
  INVALID_RECOVERY_CODE: '인증번호가 올바르지 않거나 만료·사용되었습니다. 다시 확인하거나 새 인증번호를 받아 주세요.',
  ACCOUNT_SMS_CODE_LOCKED: '인증번호를 5번 틀렸습니다. 새 인증번호를 받아 주세요.',
}
export const recoveryMessage = error => messages[error?.code] || error?.message || '요청을 처리하지 못했습니다.'
export const validRecoveryPassword = value => [...value].length >= 8 && /[A-Za-z]/.test(value) && Boolean(value.trim()) && new TextEncoder().encode(value).length <= 72
